import React from 'react';
import type CsmSettingsType from '@atlassian/jira-spa-apps-project-settings-csm/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyCsmSettings = lazyForPaint<typeof CsmSettingsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-csm", jiraSpaEntry: "async-project-settings-csm" */ '@atlassian/jira-spa-apps-project-settings-csm'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage Page={LazyCsmSettings} pageId="project-settings-csm" shouldShowSpinner={false} />
);
